import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-demohome',
  templateUrl: './demohome.component.html',
  styleUrls: ['./demohome.component.css']
})
export class DemohomeComponent implements OnInit {

  pageindex:any=1;

  urlname: any = "";

  routerEventSubscription = Subscription.EMPTY;

  constructor(public loginService:LoginDataService,public router: Router, private cuurenctRoute: ActivatedRoute) { 
    this.routerEventSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.fnGetUrlParameters()        
      });

  }

  fnGetUrlParameters() {
    this.urlname = this.cuurenctRoute.snapshot.paramMap.get('urlname');
  }

  

  ngOnInit() {
   
    setTimeout(()=>{                           
      this.pageindex=2
    }, 2000);
       
  }

  ngOnDestroy(): void {
    if (this.routerEventSubscription !== undefined) {
      this.routerEventSubscription.unsubscribe();
    }
  }

  fnMenuComponentPageChanged(event) {
     this.pageindex=event
  }

 
}
